import classNames from 'classnames';
import Typography from '@alltrails/core/components/Typography';
import WeatherIcon from '@alltrails/denali/components/WeatherIcon';
import Aqi from '@alltrails/denali/icons/Aqi';
import TrailBuggy from '@alltrails/denali/icons/TrailBuggy';
import IconRenderer, { IconDefinition } from '@alltrails/denali/components/IconRenderer';
import TrailConditionAlert from '../../types/TrailConditionAlert';
import styles from './styles/styles.module.scss';

const outerSvgWidth = 32;
const outerSvgHeight = 28;
const innerSvgSize = 12;

type ConditionAlertIconProps = {
  icon: IconDefinition<never>;
  level: 'moderate' | 'high' | 'extreme';
};

const ConditionAlertIcon = ({ icon, level }: ConditionAlertIconProps) => {
  const renderFilledPath = () => {
    switch (level) {
      case 'moderate':
        return (
          <path
            d="M5.1577 27.1753C4.89735 27.4357 4.47409 27.4366 4.22481 27.1656C2.23878 25.0068 0.881378 22.3399 0.307436 19.4545C-0.309929 16.3508 0.00692558 13.1337 1.21793 10.2101C2.42893 7.28646 4.47969 4.7876 7.11088 3.02949C9.557 1.39504 12.4026 0.469062 15.3335 0.346892C15.7014 0.331558 16 0.631485 16 0.999674V2.51242C16 2.88061 15.7013 3.17732 15.3336 3.19597C12.9659 3.31606 10.6701 4.07424 8.69207 5.39592C6.52892 6.84129 4.84295 8.89565 3.84736 11.2992C2.85177 13.7028 2.59128 16.3476 3.09883 18.8992C3.56294 21.2325 4.6502 23.392 6.23948 25.1511C6.48631 25.4243 6.48772 25.8453 6.22737 26.1056L5.1577 27.1753Z"
            fill="#EEA82F"
          />
        );
      case 'high':
        return (
          <path
            d="M5.1577 27.1753C4.89735 27.4357 4.47404 27.4365 4.22475 27.1656C1.5134 24.2185 0 20.3538 0 16.333C0 12.0895 1.68571 8.01988 4.68629 5.0193C7.68687 2.01872 11.7565 0.333009 16 0.333008C20.0207 0.333007 23.8855 1.84641 26.8325 4.55776C27.1035 4.80705 27.1027 5.23035 26.8423 5.4907L25.7726 6.56037C25.5123 6.82072 25.0913 6.81932 24.8181 6.57248C22.4065 4.39359 19.2659 3.17908 16 3.17908C12.5114 3.17909 9.16561 4.56494 6.69877 7.03178C4.23193 9.49862 2.84608 12.8444 2.84608 16.333C2.84608 19.5989 4.06058 22.7395 6.23948 25.1511C6.48631 25.4243 6.48772 25.8453 6.22737 26.1056L5.1577 27.1753Z"
            fill="#EEA82F"
          />
        );
      case 'extreme':
        return (
          <path
            d="M5.1577 27.1753C4.89735 27.4357 4.47409 27.4366 4.22481 27.1656C2.23878 25.0068 0.881378 22.3399 0.307436 19.4545C-0.309929 16.3508 0.00692558 13.1337 1.21793 10.2101C2.42893 7.28646 4.47969 4.7876 7.11088 3.02949C9.74206 1.27139 12.8355 0.333008 16 0.333008C19.1645 0.333008 22.2579 1.27139 24.8891 3.02949C27.5203 4.7876 29.5711 7.28645 30.7821 10.2101C31.9931 13.1337 32.3099 16.3508 31.6926 19.4545C31.1186 22.3399 29.7612 25.0068 27.7752 27.1656C27.5259 27.4366 27.1027 27.4357 26.8423 27.1753L25.7726 26.1056C25.5123 25.8453 25.5137 25.4243 25.7605 25.1511C27.3498 23.392 28.4371 21.2325 28.9012 18.8992C29.4087 16.3476 29.1482 13.7028 28.1526 11.2992C27.1571 8.89565 25.4711 6.84129 23.3079 5.39592C21.1448 3.95055 18.6016 3.17908 16 3.17908C13.3984 3.17908 10.8552 3.95055 8.69207 5.39592C6.52892 6.84129 4.84295 8.89565 3.84736 11.2992C2.85177 13.7028 2.59128 16.3476 3.09883 18.8992C3.56294 21.2325 4.6502 23.392 6.23948 25.1511C6.48631 25.4243 6.48772 25.8453 6.22737 26.1056L5.1577 27.1753Z"
            fill="#B24B34"
          />
        );
      default:
        return null;
    }
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={outerSvgWidth}
      height={outerSvgHeight}
      viewBox={`0 0 ${outerSvgWidth} ${outerSvgHeight}`}
      fill="none"
    >
      <path
        d="M4.99308 27.3399C4.82364 27.5094 4.54844 27.5097 4.38366 27.3358C2.31111 25.1477 0.896553 22.4161 0.307436 19.4545C-0.309929 16.3508 0.00692558 13.1337 1.21793 10.2101C2.42893 7.28646 4.47969 4.7876 7.11088 3.02949C9.74206 1.27139 12.8355 0.333008 16 0.333008C19.1645 0.333008 22.2579 1.27139 24.8891 3.02949C27.5203 4.7876 29.5711 7.28645 30.7821 10.2101C31.9931 13.1337 32.3099 16.3508 31.6926 19.4545C31.1034 22.4161 29.6889 25.1477 27.6163 27.3358C27.4516 27.5097 27.1764 27.5094 27.0069 27.3399L25.6558 25.9888C25.4864 25.8194 25.487 25.5451 25.6507 25.3702C27.3353 23.5714 28.4856 21.3351 28.9675 18.9124C29.4776 16.3477 29.2158 13.6893 28.2151 11.2734C27.2144 8.85743 25.5197 6.79252 23.3455 5.33972C21.1712 3.88692 18.615 3.11149 16 3.11149C13.385 3.11149 10.8288 3.88692 8.65452 5.33972C6.48025 6.79252 4.78561 8.85744 3.78491 11.2734C2.7842 13.6893 2.52237 16.3477 3.03253 18.9124C3.51443 21.3351 4.66475 23.5714 6.34925 25.3702C6.51304 25.5451 6.51362 25.8194 6.34419 25.9888L4.99308 27.3399Z"
        fill="#4C401A"
        fillOpacity="0.08"
      />
      {renderFilledPath()}
      <foreignObject
        x={outerSvgWidth / 2 - innerSvgSize / 2}
        y={outerSvgHeight / 2 - innerSvgSize / 2 + 2} // A little extra needed due to the asymmetry
        width={innerSvgSize}
        height={innerSvgSize}
        viewBox={`0 0 ${innerSvgSize} ${innerSvgSize}`}
      >
        <IconRenderer defaults={{}} icon={icon} />
      </foreignObject>
    </svg>
  );
};

type ConditionAlertProps = {
  className?: string;
} & TrailConditionAlert;

const ConditionAlert = ({ alertType, className, iconCode, text }: ConditionAlertProps) => {
  const renderIcon = () => {
    if (alertType) {
      switch (alertType) {
        case 'airQualityPoor':
          return <ConditionAlertIcon icon={{ Component: Aqi }} level="moderate" />;
        case 'airQualityVeryPoor':
          return <ConditionAlertIcon icon={{ Component: Aqi }} level="high" />;
        case 'airQualityExtremelyPoor':
          return <ConditionAlertIcon icon={{ Component: Aqi }} level="extreme" />;
        case 'mosquitoModerate':
          return <ConditionAlertIcon icon={{ Component: TrailBuggy }} level="moderate" />;
        case 'mosquitoHigh':
          return <ConditionAlertIcon icon={{ Component: TrailBuggy }} level="high" />;
        case 'mosquitoVeryHigh':
          return <ConditionAlertIcon icon={{ Component: TrailBuggy }} level="extreme" />;
        default:
          break;
      }
    }
    if (iconCode !== undefined) {
      return <WeatherIcon iconCode={iconCode} size="sm" />;
    }
    return null;
  };

  return (
    <div className={classNames(styles.container, className)}>
      {renderIcon()}
      <Typography variant="text100">{text}</Typography>
    </div>
  );
};

export default ConditionAlert;
